import axios from "../../lib/axiosInstance";

const get = (path, params = {}) => {
  const q = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
  );
  return axios.get(`analytics/${path}?${q}`).then((r) => r.data);
};

// The viewer's IANA zone, e.g. "Asia/Karachi". The KPI "Today" card needs it to
// know where the calendar day begins — orderStartDate stores a local date, so a
// UTC boundary showed yesterday's jobs until mid-morning. Undefined on very old
// browsers, in which case the server falls back to its configured default.
const browserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
};

export const fetchFilterOptions = () => get("filterOptions");
// tz is applied here rather than at the call sites so it can't be forgotten.
export const fetchKpiMetrics = (params) => get("kpi", { ...params, tz: browserTimeZone() });
export const fetchTrends = (params) => get("trends", params);
export const fetchAnnualTarget = (params) => get("target", params);
export const fetchWorkOrderAnalytics = (params) => get("workOrders", params);
export const fetchMonthlyAnalytics = (params) => get("monthly", params);
export const fetchTopClients = (params) => get("topClients", params);
export const fetchTeamTrends = (params) => get("teamTrends", params);
export const fetchClientYearlyTrends = (params) => get("clientTrends", params);
export const fetchBreakdownAnalytics = (params) => get("breakdown", params);
export const fetchWorldMap = (params) => get("worldMap", params);
export const fetchAdvancedAnalytics = (params) => get("advanced", params);
export const fetchClientMonthlyRace = (params) => get("clientMonthlyRace", params);
